import { CalendarIcon, InfoCircledIcon, ChevronDownIcon, ChevronRightIcon } from "@radix-ui/react-icons";
import { getMappedFieldValue } from '../utils/getMappedFieldValue';

const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('fr-FR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  });
};

const IssueCard = ({
  color,
  issueKey,
  interventionPoint,
  createdAt,
  dueDate,
  status,
  statusColor,
  summary,
  onClick,
  children = null,
  isChild = false,
  hasChildren = false,
  isExpanded = false,
  onToggleExpand = null
}) => {
  const number = issueKey.split('-')[1];
  const interventionPointValue = getMappedFieldValue(interventionPoint);

  return (
    <>
      <div
        className={`bg-white rounded-[16px] p-3 border cursor-pointer group ${
          isChild
            ? 'ml-6 border-l-4 border-l-black border-t border-r border-b border-gray-200'
            : 'border-gray-200 border-l-2'
        }`}
        style={!isChild ? { borderLeftColor: color } : {}}
      >
        <div className="flex items-start justify-between">
          <div className="flex-1 gap-1 min-w-0" onClick={onClick}>
            <div className="flex items-center gap-2 mb-1 justify-between">
              <div className="flex items-center justify-between w-full">
                <span className="text-[14px] font-bold text-[#3d3d3d] leading-tight truncate flex-1 min-w-0">
                  {interventionPointValue || issueKey}
                </span>
                <span className="text-[14px] font-medium text-gray-500 ml-2 flex-shrink-0">
                  #{number}
                </span>
              </div>
            </div>
            <div className="flex flex-col">
              {summary && (
                <span className="text-[14px] text-gray-600 flex font-medium truncate flex flex-row items-center gap-[6px]">
                  <InfoCircledIcon className="w-[14px] h-[14px]" />
                  {summary}
                </span>
              )}
            </div>
            <div className="flex items-center justify-between">
              <div>
                {/* {createdAt && (
                  <p className="text-[14px] text-gray-500">
                    Créé le {formatDate(createdAt)}
                  </p>
                )} */}

                <p className="text-[12px] text-gray-500">
                  Créé le {formatDate(createdAt)}
                </p>

                {dueDate && (
                  <span className="text-[14px] text-gray-600 flex flex-row items-center gap-[6px]">
                    <CalendarIcon className="w-[14px] h-[14px]" />
                    Prévu le {formatDate(dueDate)}
                  </span>
                )}

              </div>
              <div>
              {status && (
                <span className={`uppercase inline-flex px-2 py-0.5 text-[10px] font-semibold rounded-full ${statusColor}`}>
                  {status}
                </span>
              )}
              </div>
            </div>
          </div>
          {/* Bouton d'expansion pour les parents avec enfants */}
          {hasChildren && onToggleExpand && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onToggleExpand();
              }}
              className="ml-3 p-2.5 rounded-full transition-all duration-200 flex-shrink-0
                         bg-gradient-to-br from-gray-50 to-gray-100
                         hover:from-blue-50 hover:to-blue-100
                         hover:shadow-md hover:scale-110
                         active:scale-95
                         border border-gray-200 hover:border-blue-300"
            >
              {isExpanded ? (
                <ChevronDownIcon className="w-4 h-4 text-gray-700 transition-transform duration-200" />
              ) : (
                <ChevronRightIcon className="w-4 h-4 text-gray-700 transition-transform duration-200" />
              )}
            </button>
          )}
        </div>
      </div>
      {/* Render child issues if they exist and parent is expanded */}
      {isExpanded && children}
    </>
  );
};

export { IssueCard };
